module.exports = __webpack_public_path__ + "static/media/variable4.fccd97a6.png";